import { render, staticRenderFns } from "./DealerItem.vue?vue&type=template&id=32cc0900&"
import script from "./DealerItem.js?vue&type=script&lang=js&"
export * from "./DealerItem.js?vue&type=script&lang=js&"
import style0 from "./DealerItem.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports